module.exports = __webpack_public_path__ + "media/images/konintodoke/konintodoke-top-basic-step-finish-f5d78ad9b0cecea9d11865dbfa2f9ee9.png";